import { BlogPost } from "../type";
import { BlogItem } from "./BlogItem";

type BlogListProps = {
  blogPosts: BlogPost[];
};

export function BlogList({ blogPosts }: BlogListProps) {
  return (
    <div className="divide-y">
      {blogPosts.map((blogPost) => (
        <BlogItem key={blogPost.id} blogPost={blogPost} />
      ))}
    </div>
  );
}
